import { Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CookieConsent from "./CookieConsent";
import { useLanguage } from "@/i18n/useLanguage";
import logoEn from "@/assets/logo-footer-en.png";
import logoSv from "@/assets/logo-footer-sv.png";

const Footer = () => {
  const [cookieConsentOpen, setCookieConsentOpen] = useState(false);
  const { t } = useTranslation();
  const { localize, lang } = useLanguage();
  const footerLogo = lang === "sv" ? logoSv : logoEn;

  return <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img
              src={footerLogo}
              alt={t("footer.companyName")}
              className="h-10 md:h-12 w-auto mb-4 object-contain object-left"
              loading="lazy"
            />
            <p className="text-muted-foreground mb-4">{t("footer.orgNo")}</p>
            <div className="flex gap-4">
              <a href="https://www.linkedin.com/company/ai-labbet/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">{t("footer.quickLinks")}</h4>
            <ul className="space-y-2">
              <li>
                <Link to={localize("/about")} className="text-muted-foreground hover:text-primary transition-colors">
                  {t("nav.about")}
                </Link>
              </li>
              <li>
                <Link to={localize("/services")} className="text-muted-foreground hover:text-primary transition-colors">
                  {t("nav.services")}
                </Link>
              </li>
              <li>
                <Link to={localize("/ai-skilling")} className="text-muted-foreground hover:text-primary transition-colors">
                  {t("nav.aiSkilling")}
                </Link>
              </li>
              <li>
                <Link to={localize("/news")} className="text-muted-foreground hover:text-primary transition-colors">
                  {t("nav.news")}
                </Link>
              </li>
              <li>
                <Link to={localize("/newsletter")} className="text-muted-foreground hover:text-primary transition-colors">
                  {t("nav.newsletter")}
                </Link>
              </li>
              <li>
                <Link to={localize("/norr-om-framtiden")} className="text-muted-foreground hover:text-primary transition-colors">
                  Norr om framtiden
                </Link>
              </li>

            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">{t("footer.contactUs")}</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li>
                <Link to={localize("/contact")} className="hover:text-primary transition-colors">
                  {t("nav.contact")}
                </Link>
              </li>
              <li>Malmskillnadsgatan 36, 111 57 Stockholm</li>
              <li>
                <a href="mailto:info@ailabbet.com" className="hover:text-primary transition-colors">
                  info@ailabbet.com
                </a>
              </li>
            </ul>
          </div>
        </div>



        <div className="border-t border-border mt-8 pt-8 text-center text-sm text-muted-foreground">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <p>&copy; {new Date().getFullYear()} AI Lab Sweden AB. {t("footer.rights")}</p>
            <div className="flex items-center gap-3">
              <Link to={localize("/privacy-policy")} className="hover:text-primary transition-colors">
                {t("footer.privacy")}
              </Link>
              <span>·</span>
              <button 
                onClick={() => setCookieConsentOpen(true)}
                className="hover:text-primary transition-colors"
              >
                {t("footer.cookies")}
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <CookieConsent isOpen={cookieConsentOpen} onOpenChange={setCookieConsentOpen} />
    </footer>;
};
export default Footer;
